import React, { useEffect, useState, useRef, useContext } from "react";
import { Button, Col, Row } from "react-bootstrap";
import DefaultLoader from "../jsx/components/Loader";
import Swal from "sweetalert2";
import AlertResponses from "../jsx/components/Alert";
import ProgressBarComponent from "../jsx/components/ProgressBar";
import ModalComponent from "../jsx/components/Modal";
// import Tutorial from "../jsx/components/Tutorial";
import UserContext from "../contexts/UserContext";
import styled from "styled-components";
import WhatsappTemplatesUpsert from "./WhatsappTemplatesUpsert";
import { bulkDelete, getTemplates } from "../services/TemplatesServices";

// Styled Components
const Container = styled.div`
  margin: 0;
  background: #f8f9fa;

  @media (max-width: 768px) {
    background: #ffffff;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
`;

const Title = styled.h2`
  color: #212529;
  font-weight: 700;
  font-size: 28px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
    text-align: center;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 16px;
  background: white;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #6c757d;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 18px;
`;

const ActionsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const SelectionInfo = styled.div`
  color: #495057;
  font-weight: 500;
  font-size: 14px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const DeleteButton = styled.button`
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #c82333;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 100px;
  }
`;

const TemplateCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid ${(props) => (props.selected ? "#007bff" : "transparent")};
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    border-radius: 12px;
    padding: 16px;

    &:hover {
      transform: none;
    }

    &:active {
      background: #f8f9fa;
    }
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

const CardTitle = styled.h3`
  color: #212529;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  margin-right: 12px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CardCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #007bff;
`;

const CardContent = styled.div`
  margin-bottom: 16px;
`;

const MessagePreview = styled.p`
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TypeBadge = styled.span`
  display: inline-block;
  background: ${(props) => {
    switch (props.type) {
      case "Áudio":
        return "#28a745";
      case "Documento":
        return "#6c757d";
      case "Imagem":
        return "#17a2b8";
      default:
        return "#007bff";
    }
  }};
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
`;

const UpdateDate = styled.span`
  color: #6c757d;
  font-size: 12px;
`;

const EditButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #0056b3;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #0056b3;
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    bottom: 70px;
    right: 10px;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 32px 0;

  @media (max-width: 768px) {
    margin: 24px 0;
    flex-wrap: wrap;
  }
`;

const PaginationButton = styled.button`
  background: ${(props) => (props.active ? "#007bff" : "white")};
  color: ${(props) => (props.active ? "white" : "#495057")};
  border: 2px solid ${(props) => (props.active ? "#007bff" : "#dee2e6")};
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 40px;

  &:hover:not(:disabled) {
    background: ${(props) => (props.active ? "#0056b3" : "#e9ecef")};
    border-color: ${(props) => (props.active ? "#0056b3" : "#adb5bd")};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;

  h3 {
    color: #495057;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 24px;
  }
`;

const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

export default function WhatsappTemplates() {
  const { user, bottyData, accountLoading } = useContext(UserContext);
  const [whatsappTemplatesData, setWhatsappTemplatesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [notify, setNotify] = useState({
    title: "",
    message: "",
    type: "",
    visible: false,
  });
  const [progress, setProgress] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const data = useRef();
  const insertOrUpdate = useRef();

  useEffect(() => {
    // Aguardar o carregamento da conta WhatsApp terminar
    if (accountLoading) {
      return; // Não processar ainda se estiver carregando
    }

    if (bottyData && Array.isArray(bottyData) && bottyData.length > 0) {
      // Usar a primeira conta disponível
      const firstAccount = bottyData[0];
      if (firstAccount?.uid && firstAccount?.id) {
        let payload = `?uid=${firstAccount.uid}&aid=${firstAccount.id}`;
        getTemplates(payload).then((data) => {
          setWhatsappTemplatesData(data.results || []);
          setFilteredData(data.results || []);
          setIsLoading(false);
        }).catch(() => {
          setIsLoading(false);
        });
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, [bottyData, accountLoading]);

  // Filter data based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredData(whatsappTemplatesData);
    } else {
      const filtered = whatsappTemplatesData.filter((template) =>
        template.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
    setCurrentPage(1);
  }, [searchTerm, whatsappTemplatesData]);

  // Update delete button visibility
  useEffect(() => {
    setShowDeleteButton(selectedRows.length > 0);
  }, [selectedRows]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleCheckboxChange = (templateId, isChecked) => {
    if (isChecked) {
      setSelectedRows((prev) => [...prev, templateId]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== templateId));
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedRows(currentData.map((template) => template.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleDelete = () => {
    Swal.fire({
      title: "Você tem certeza?",
      text: "Todos os templates selecionados serão deletados. Esta ação é irreversível!",
      icon: "warning",
      buttons: true,
      confirmButtonText: `Continuar a ação`,
      cancelButtonText: `Cancelar`,
      showCancelButton: true,
      confirmButtonColor: "red",
    }).then((value) => {
      if (value.isConfirmed) {
        let payload = {
          ids: selectedRows,
          account_id: user.account_id,
        };

        bulkDelete(payload, setNotify, setProgress).then((res) => {
          if (res) {
            setSelectedRows([]);
            setShowDeleteButton(false);
            // Refresh data
            if (bottyData && Array.isArray(bottyData) && bottyData.length > 0) {
              const firstAccount = bottyData[0];
              if (firstAccount?.uid && firstAccount?.id) {
                let payload = `?uid=${firstAccount.uid}&aid=${firstAccount.id}`;
                getTemplates(payload).then((data) => {
                  setWhatsappTemplatesData(data.results || []);
                  setFilteredData(data.results || []);
                });
              }
            }
          }
        });
      }
    });
  };

  const getMessageType = (message) => {
    try {
      let type = JSON.parse(message);

      type = Object.keys(type)[0];

      switch (type) {
        case "audio":
          return "Áudio";
        case "document":
          return "Documento";
        case "image":
          return "Imagem";
        default:
          return "Texto";
      }
    } catch (error) {
      return "Texto";
    }
  };

  const getMessageText = (message) => {
    try {
      return message.text || "Sem prévia disponível";
    } catch (error) {
      return "Sem prévia disponível";
    }
  };

  const formatDate = (dateString) => {
    return dateString ? new Date(dateString).toLocaleString("pt-BR") : "";
  };

  const modalProps = {
    title:
      insertOrUpdate.current === "insert"
        ? "Novo template"
        : "Atualizar template",
    content: (
      <WhatsappTemplatesUpsert
        data={data.current}
        insertOrUpdate={insertOrUpdate}
        setNotify={setNotify}
        setShowModal={setShowModal}
        bottyData={bottyData}
        setWhatsappTemplatesData={setWhatsappTemplatesData}
      />
    ),
    size: "xl",
    btnLabel: "Salvar",
    showModal: showModal,
    setShowModal: setShowModal,
    showFooter: false,
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    pages.push(
      <PaginationButton
        key="prev"
        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
        disabled={currentPage === 1}
      >
        ←
      </PaginationButton>
    );

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PaginationButton
          key={i}
          active={i === currentPage}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    // Next button
    pages.push(
      <PaginationButton
        key="next"
        onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
        disabled={currentPage === totalPages}
      >
        →
      </PaginationButton>
    );

    return <PaginationContainer>{pages}</PaginationContainer>;
  };

  if (isLoading || accountLoading) {
    return <DefaultLoader isLoading={isLoading || accountLoading} />;
  }

  if (!bottyData || !Array.isArray(bottyData) || bottyData.length === 0) {
    return (
      <Row>
        <Col lg={6} className="d-flex justify-content-center align-items-center mx-auto my-4">
          <h4 className="text-center">
            Você precisa estar conectado a uma conta do whatsapp para criar
            templates.
          </h4>
        </Col>
      </Row>
    );
  }

  return (
    <Container className="">
      {/*    <Tutorial
        videoId={"FsYXmvwkpTM"}
        padding={"0 15px"}
        badgeClasses={"mr-3"}
      /> */}

      <Header>
        <Title>Templates</Title>
      </Header>

      <SearchContainer>
        <SearchIcon>🔍</SearchIcon>
        <SearchInput
          type="text"
          placeholder="Buscar templates..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </SearchContainer>

      {(selectedRows.length > 0 || filteredData.length > 0) && (
        <ActionsBar>
          <SelectionInfo>
            {selectedRows.length > 0
              ? `${selectedRows.length} template${
                  selectedRows.length > 1 ? "s" : ""
                } selecionado${selectedRows.length > 1 ? "s" : ""}`
              : `${filteredData.length} template${
                  filteredData.length > 1 ? "s" : ""
                } encontrado${filteredData.length > 1 ? "s" : ""}`}
          </SelectionInfo>

          {showDeleteButton && (
            <DeleteButton onClick={handleDelete}>
              Deletar Selecionados
            </DeleteButton>
          )}
        </ActionsBar>
      )}

      {notify.visible && (
        <AlertResponses
          title={notify.title}
          message={notify.message}
          type={notify.type}
          visible={notify.visible}
          setNotify={setNotify}
        />
      )}

      {currentData.length === 0 ? (
        <EmptyState>
          <EmptyIcon>📄</EmptyIcon>
          <h3>Nenhum template encontrado</h3>
          <p>
            {searchTerm
              ? "Tente ajustar sua busca ou criar um novo template."
              : "Comece criando seu primeiro template de mensagem."}
          </p>
          <Button
            variant="primary"
            onClick={() => {
              insertOrUpdate.current = "insert";
              data.current = null;
              setShowModal(true);
            }}
          >
            Criar Primeiro Template
          </Button>
        </EmptyState>
      ) : (
        <>
          <CardsContainer>
            {currentData.map((template) => (
              <TemplateCard
                key={template.id}
                selected={selectedRows.includes(template.id)}
                onClick={(e) => {
                  if (
                    e.target.type !== "checkbox" &&
                    !e.target.closest("button")
                  ) {
                    insertOrUpdate.current = "update";
                    data.current = template;
                    setShowModal(true);
                  }
                }}
              >
                <CardHeader>
                  <CardTitle>{template.name}</CardTitle>
                  <CardCheckbox
                    type="checkbox"
                    checked={selectedRows.includes(template.id)}
                    onChange={(e) =>
                      handleCheckboxChange(template.id, e.target.checked)
                    }
                    onClick={(e) => e.stopPropagation()}
                  />
                </CardHeader>

                <CardContent>
                  <MessagePreview>
                    {getMessageText(template.message)}
                  </MessagePreview>
                  <TypeBadge type={getMessageType(template.message)}>
                    {getMessageType(template.message)}
                  </TypeBadge>
                </CardContent>

                <CardFooter>
                  <UpdateDate>
                    {formatDate(template.updated_at || template.created_at)}
                  </UpdateDate>

                  {!template.ai_plugins && (
                    <EditButton
                      onClick={(e) => {
                        e.stopPropagation();
                        insertOrUpdate.current = "update";
                        data.current = template;
                        setShowModal(true);
                      }}
                    >
                      ✏️ Editar
                    </EditButton>
                  )}
                </CardFooter>
              </TemplateCard>
            ))}
          </CardsContainer>

          {renderPagination()}
        </>
      )}

      <FloatingButton
        onClick={() => {
          insertOrUpdate.current = "insert";
          data.current = null;
          setShowModal(true);
        }}
      >
        +
      </FloatingButton>

      {progress && <ProgressBarComponent />}
      {showModal && <ModalComponent props={modalProps} />}
    </Container>
  );
}
